import React from "react";
import { ScreenCheck, useLoggedIn } from "@redriver/cinnamon";

const BackgroundContent = () => {
  return <div className="login-img"></div>;
};

export default BackgroundContent;
